<template>
  <div>
    <van-tabbar v-model="footer_a" active-color="#fd5b5a" inactive-color="#000" route  >
      <van-tabbar-item icon="wap-home-o" to="/" >首页</van-tabbar-item>
      <van-tabbar-item icon="like-o" to="/Message">消息</van-tabbar-item>
      <van-tabbar-item icon="description" to="/News">新闻</van-tabbar-item>
      <van-tabbar-item icon="user-o"  to="/Member">我的</van-tabbar-item>
    </van-tabbar>
    </div>
</template>
<style>
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{border-width: 0px 0;}
.van-tabbar-item{border-top: 1px solid #ebedf0;}
</style>
<script>
export default {
  data(){
      return {
          footer_a: 0,

      }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue